<template>
    <Fragment>
        <VueScene
                ref="fade_out"
                :keyframes="keyframes_fadeout"
                :autoplay=false
                @ended="onFadedOut">
            <span></span>
        </VueScene>
        <VueScene
                ref="fade_in"
                :keyframes="keyframes_fadein"
                :autoplay=false>
            <span></span>
        </VueScene>
        <div class="apppage landingpage" id="landingpage" :style="showContent? 'display:block':'display: none'">
            <div class="landing_vid_bg" v-if="!isMobile()">
                <video class="videoInsert" autoplay muted loop >
                    <source src="../assets/rolling-footage.mp4" type="video/mp4">
                </video>
            </div>
            <div class="landing_bg" v-if="isMobile()"></div>
            <div class="landing_intro">
                Explore this interactive collaboration of music, dance and cinematography
                from Scottish Dance Theatre, Scottish Ensemble and composer Martin Suckling
            </div>
            <div class="blackbar_top" v-if="!isMobile()"></div>
            <div class="blackbar_bottom" v-if="!isMobile()"></div>
            <button class="wizard_btn" @click="onBegin">begin</button>
        </div>
    </Fragment>
</template>

<script>

    import { VueScene } from "vue-scenejs";
    import { Fragment } from 'vue-fragment'

    export default {
        name: 'LandingPage',
        components:{
            VueScene,
            Fragment
        },
        props: {
            initiallyVisible: Boolean
        },
        mounted: function(){
            this.$refs.fade_in.play();
        },
        methods:{
            onBegin: function() {
                this.$emit('begin-clicked');
            },
            onFadedOut: function() {
                this.showContent = false;
            },
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            }
        },
        watch: {
            visible: function(newVal) {
                this.showContent = true;

                if(newVal){
                    this.$refs.fade_in.play();
                } else{
                    this.$refs.fade_out.play();
                }

            }
        },
        data() {
            return {
                visible: this.initiallyVisible,
                showContent: this.initiallyVisible,
                "keyframes_fadeout": {
                    "#landingpage": () => ({
                        0: {
                            "opacity": 1
                        },
                        0.5: {
                            "opacity": 0
                        },
                        easing: "linear"
                    }),
                },
                "keyframes_fadein": {
                    "#landingpage": () => ({
                        0: {
                            "opacity": 0
                        },
                        0.5: {
                            "opacity": 1
                        },
                        easing: "linear"
                    }),
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    @import "../assets/styles/variables";

    .landingpage {

        .landing_intro {
            position: absolute;
            margin: 0 19%;
            width: 62%;
            height: 151px;
            top: 25%;

            font-family: Cormorant Garamond, 'serif';
            font-style: normal;
            font-weight: 500;
            font-size: 40px;
            line-height: 55px;

            text-align: center;

            color: #FFFFFF;

            text-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);

            /* mobile */
            @media only screen and (max-width : 736px) {
                font-size: 28px;
                line-height: 38px;

                margin: 0 9%;
                width: 82%;
                top: 10%;
            }
            @media only screen and (max-height : 490px) {
                font-size: 20px;
                line-height: 24px;

                margin: 0 9%;
                width: 82%;
                top: 10%;
            }
            @media only screen and (max-height : 646px) {
                font-size: 33px;
                line-height: 42px;
            }
            @media only screen and (max-height : 646px) {
                font-size: 26px;
                line-height: 28px;
            }
        }

    }

    .landing_bg{
        background-image: url('../assets/landing-bg.jpg');
        width: 100%;
        height: 100vh;
        background-size: cover;
        position: absolute;
        background-position: center;
        top: -$header-height;
        box-sizing: border-box;
    }

    .landing_vid_bg{
        width: 100%;
        height: 100vh;
        background-size: cover;
        position: absolute;
        background-position: center;
        top: -$header-height;
        box-sizing: border-box;

        /* mobile */
        @media only screen and (max-width : 736px)  {
        }

        .videoInsert {
            position: absolute;
            bottom: calc(0.5 * (100vh - #{100 * 1080/1920}vw));
            left: 0;
            height: #{100 * 1080/1920}vw;
            width: 100vw;
            background-size: cover;
            overflow: hidden;
            @media (max-aspect-ratio: 1920/1080) {
                bottom: 0;
                //bottom: calc(100vh - var(--vh, 1vh) * 100);
                left: calc(-1 * (100vh - #{100 * 1080/1920}vw));
                height: 100vh;
                width: #{100 * 1920/1080}vh;
            }
        }
    }

    .blackbar_top{
        background-color: #000;
        width: 100%;
        height: $header-height;
        top: -$header-height;
        position: absolute;
    }

    .blackbar_bottom{
        background-color: #000;
        width: 100%;
        height: $header-height;
        bottom: 0;
        //bottom: calc(100vh - var(--vh, 1vh) * 100);
        position: absolute;
    }

</style>
